import { createRoot } from "react-dom/client";
import "./index.css";
import "./index-print.css";
import ReactModal from "react-modal";
import { createBrowserRouter, RouterProvider } from "react-router";
import { appRoutes } from "./AppRoutes";

ReactModal.setAppElement("#root");

const router = createBrowserRouter(appRoutes);

createRoot(document.getElementById("root")!).render(
  <RouterProvider router={router} />
);
